var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44.2527,
    height: 59,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 45,
    height: 59,
    transform: "matrix(-1 0 0 1 89 0)",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9637 8.80931L22.831 8.22956L21.5241 8.52884L21.7027 9.30843L12.4723 53.1532L13.7842 53.4294L22.4165 12.4255L31.5791 52.4354L32.8859 52.1362L23.0753 9.29633L23.1687 8.85246L22.9637 8.80931Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2819 8.8083L68.4121 8.2334L69.7176 8.52482L69.541 9.30464L78.6716 53.1546L77.3591 53.4279L68.8275 12.4547L59.7725 52.4314L58.467 52.14L68.1706 9.29983L68.0771 8.85095L68.2819 8.8083Z",
    fill: "#7ABB5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9823 30.2974L39.2827 30.2122L39.1348 29.6907L39.2633 29.1797L38.969 29.1057L38.9171 28.9224L38.5988 29.0126L8.59934 21.4709L8.27248 22.7711L36.0142 29.7452L7.24766 37.8991L7.61327 39.189L38.6196 30.4002L38.9365 30.4799L38.9823 30.2974Z",
    fill: "#7ABB5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.447 30.3006L52.1406 30.2128L52.2918 29.6902L52.1622 29.1801L52.4615 29.104L52.5142 28.9219L52.8262 29.0113L82.4911 21.4713L82.8214 22.7707L55.3843 29.7444L83.8375 37.8986L83.464 39.1896L52.799 30.4015L52.4924 30.4794L52.447 30.3006Z",
    fill: "#7ABB5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.cb933c4299bcebf82b2181d6c3250961.svg";
export { ForwardRef as ReactComponent };